import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import color from "@stoneage/XDL/Utilities/color";
import { css } from "styled-components";

const spanStyles = css`
    border-radius: 0px;
    margin-top: 1px;

    & + label {
        margin-left: 8px;
    }

    & :focus {
        box-shadow: unset;
    }

    & :hover {
        border: 1px solid ${color("common.black")};
    }
`;

export const blackCheckbox = {
    checkBox: {
        css: css<CheckboxStyleProps>`
            align-items: flex-start;

            && span[role="checkbox"] {
                ${spanStyles}
                background-color: ${color("common.white")};
            }
        `,
        typographyProps: {
            size: 12,
            css: css`
                word-break: break-all;
            `,
        },
    },
    checkBoxSelected: {
        css: css<CheckboxStyleProps>`
            align-items: flex-start;

            &&& span[role="checkbox"] {
                ${spanStyles}
                background-color: ${color("common.black")};
            }

            & svg {
                height: 12px;
            }
        `,
        typographyProps: {
            size: 12,
            css: css`
                word-break: break-all;
            `,
        },
    },
};
